(function() {
  function syncStickyCartVariantSelect(event) {
    var variant = event.detail && event.detail.originalVariantObject;
    if (!variant || !variant.id) return;

    document.querySelectorAll('.js-product-sticky-cart [data-product-select], .js-product-sticky-cart-mobile [data-product-select]').forEach(function(select) {
      select.value = variant.id;

      // The desktop sticky cart's variant select is enhanced by the "nice-select"
      // jQuery plugin (see main.build.min.js: $(".product-sticky-cart__options-wrapper
      // > .product-common-selector").niceSelect()). nice-select builds its own
      // "<span class=current>" + "<li>" dropdown UI from the select's state once, at
      // init time, and never looks at the underlying <select> again on its own -
      // setting select.value here does not touch that UI. It has to be told to
      // rebuild itself, or it keeps showing whatever variant was selected at page load.
      if (window.jQuery) {
        var $select = window.jQuery(select);
        if ($select.next('.nice-select').length) {
          $select.niceSelect('update');
        }
      }
    });

    // The theme's built-in sync (theme.ProductStickyCartDesktop/Mobile.updateOptions)
    // checks the matching swatch radio via jQuery .prop('checked', true), which does
    // not fire a native 'change' event. The "<Option>: <value>" text label next to
    // each swatch group is only updated by a 'change' listener local to that swatch
    // instance (see swatch-new.liquid), so it never picks up selections made in a
    // different swatch instance (e.g. main page -> mobile sticky popup). Update it
    // here directly from the variant data instead.
    document.querySelectorAll('[data-swatch-selected-name]').forEach(function(nameContainer) {
      var index = nameContainer.getAttribute('data-index');
      var value = index && variant[index];
      if (!value) return;
      var valueEl = nameContainer.querySelector('[data-swatch-selected-name-value]');
      if (valueEl) valueEl.textContent = value;
    });
  }

  document.addEventListener('productVariantChange', syncStickyCartVariantSelect);
})();
